import { Routes, Route, Navigate } from 'react-router-dom';
import NavBar from './components/NavBar';
import HomePage from './components/pages/HomePage';
import RoomsPage from './components/pages/RoomsPage';
import RoomDetailPage from './components/pages/RoomDetailPage';
import Footer from './components/Footer';
import './App.css';
import GalleryPage from './components/pages/GalleryPage';
import BookingSearch from './components/pages/BookingSearch';
import Faqs from './components/pages/Faqs';
import LocationPage from './components/pages/LocationPage';
import TermsAndCondsPage from './components/pages/TermsAndCondsPage';
import NotFound from './components/pages/NotFound';
import SEO from './components/SEO';
import BlogListPage from './components/pages/BlogListPage';
import BlogDetailPage from './components/pages/BlogDetailPage';


function App() {
  return (
    <div className="relative flex min-h-screen w-full flex-col group/design-root overflow-x-hidden">
      <div className="layout-container flex h-full grow flex-col">
        <NavBar />
        <main className="flex flex-col items-center w-full">
          <div className="layout-content-container flex flex-col w-full max-w-6xl">
            <Routes>
              <Route path="/:lang">
                <Route index element={<><SEO /><HomePage /></>} />
                <Route path="rooms" element={<><SEO /><RoomsPage /></>} />
                <Route path="book-a-room" element={<><SEO /><RoomsPage /></>} />
                <Route path="room/:id" element={<><SEO /><RoomDetailPage /></>} />
                <Route path="location" element={<><SEO /><LocationPage /></>} />
                <Route path="gallery" element={<><SEO /><GalleryPage /></>} />
                <Route path="booking" element={<><SEO /><BookingSearch /></>} />
                <Route path="faqs" element={<><SEO /><Faqs /></>} />
                <Route path="terms-and-conditions" element={<><SEO /><TermsAndCondsPage /> </>} />

                {/* Legacy or specific routes inside /:lang */}
                <Route path="blog" element={<><SEO /><BlogListPage /></>} />
                <Route path="blog/:slug" element={<><SEO /><BlogDetailPage /></>} />
                <Route path="gallery-5-1" element={<GalleryPage />} />
                <Route path="booking/currency/:currency/checkin/:checkin/checkout/:checkout" element={<BookingSearch />} />
                <Route path="*" element={<NotFound />} />
              </Route>

              <Route path="/" element={<Navigate to="/en" replace />} />
              <Route path="*" element={<Navigate to="/en" replace />} />
            </Routes>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default App;
